import { useContext, useEffect, useState } from "react";
import { FaEdit, FaTrash, FaSave, FaSearch, FaTimes } from "react-icons/fa";
import AddDataModal from "./AddData";
import axiosInstance from "../utils/AxiosInstance";
import ConfirmationModal from "../widgets/ConfirmationModal";
import { AppContext } from "../context/AppContext";
import { useDebounce } from "../utils/usedebounce";
import Pagination from "../widgets/Pagination";
import DataReports from "./DataReports";
import AddReportsDataModal from "./AddReportsData";
import Select from "react-select";
import { useMsal } from "@azure/msal-react";
import { getActivityActor } from "../utils/activityActor";

const UserTable = () => {
  const [editRow, setEditRow] = useState({ id: "", email: "" });
  const [userOptions, setUserOptions] = useState([]);
  const [editedData, setEditedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [searchReportTerm, setSearchReportTerm] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rollUpDropdown, setRollUpDropdown] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("report");
  const [allRoles, setAllRoles] = useState();
  const [groupValue, setGroupValue] = useState();
  const [updatedGroup, setupdatedGroup] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedReport, setSelectedReport] = useState();
  const isFirefox =
    typeof navigator !== "undefined" && navigator.userAgent.includes("Firefox");
  const {
    setLoader,
    setToast,
    setViewerEmails,
    confirmationModal,
    setConfirmationModal,
    loader,
    setReportOptions,
    pipelines,
    setPipelines,
    setWorkSpaces,
    workSpaceReports,
    setWorkSpaceReports,
    tableReport,
    setTableReport,
    setfieldTable,
emailOptionTitle,setemailOptionTitle,
    setSelectedWorkspace,
    setSelectedPipeline,
    setselectedTable,
    setSelectedField,
    setSelectedValue,
    setUserId,
    setValueField,
    ValueField,setReportId,rlsType, setRlsType,editData, setEditData,currentPage:currentPageReport, setcurrentPageReport
  } = useContext(AppContext);
  const [dataReport, setDataReport] = useState([]);
  const [data, setData] = useState({ rows: [] });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedReportRows, setSelectedReportRows] = useState([]);
  const [resetReports, setResetReports] = useState(false);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const actor = getActivityActor(account);
  // const handleSelectAll = () => {
  //   const currentPageRows = data.rows;
  //   if (selectedRows.length === currentPageRows.length) {
  //     setSelectedRows([]);
  //   } else {
  //     const selectedRowIdentifiers = currentPageRows.map((item) => ({
  //       VALUE: item.VALUE,
  //       EMAIL: item.EMAIL,
  //       REPORT: Array.isArray(item.REPORT) ? item.REPORT[0] : item.REPORT,
  //       //  REPORT:item.REPORT[0],
  //     }));
  //     setSelectedRows(selectedRowIdentifiers);
  //   }
  // };

   const handleSelectAll = () => {
  const currentPageRows = data.rows.map((item) => ({
    VALUE: item.VALUE,
    EMAIL: item.EMAIL,
    REPORT: Array.isArray(item.REPORT) ? item.REPORT[0] : item.REPORT,
  }));

  setSelectedRows((prevSelected) => {
    const allSelectedOnPage = currentPageRows.every((row) =>
      prevSelected.some(
        (selected) =>
          selected.VALUE === row.VALUE &&
          selected.EMAIL === row.EMAIL &&
          selected.REPORT?.id === row.REPORT?.id
      )
    );

    if (allSelectedOnPage) {
      return prevSelected.filter(
        (row) =>
          !currentPageRows.some(
            (pageRow) =>
              pageRow.VALUE === row.VALUE &&
              pageRow.EMAIL === row.EMAIL &&
              pageRow.REPORT?.id === row.REPORT?.id
          )
      );
    } else {
      const newSelections = currentPageRows.filter(
        (row) =>
          !prevSelected.some(
            (selected) =>
              selected.VALUE === row.VALUE &&
              selected.EMAIL === row.EMAIL &&
              selected.REPORT?.id === row.REPORT?.id
          )
      );
      return [...prevSelected, ...newSelections];
    }
  });
};
  const fetchWorkspacesReports = async (workspaceId) => {
    setLoader(true);

    try {
      const response = await axiosInstance.post("/Get_all_reports", {
        WORKSPACE_ID: workspaceId,
      });
      if (response.data) {
        setWorkSpaceReports(
          response.data?.value?.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };
  const fetchTableReports = async (workspaceId, reportId) => {



    setLoader(true);
    try {
      const response = await axiosInstance.post("/get_tables_by_report", {
        WORKSPACE_ID: workspaceId,
        REPORT_ID: reportId,
      });

      if (response?.data) {
        setTableReport(response.data); // ✅ update state
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchFieldTable = async (tableId) => {
    setLoader(true);

    try {
      const response = await axiosInstance.post("/get_columns_by_table", {
        tableId: tableId,
      });
      if (response.data) {
        setfieldTable(response?.data);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };
  const fetchValueField = async () => {
    setLoader(true);
    
    try {
      const response = await axiosInstance.get("/client-rollup");
      if (response.data) {
        setValueField(response.data);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchValueField();
  }, []);
  // const handleRowSelection = (gl, email) => {
  //   const rowIdentifier = { GL: gl, EMAIL: email };

  //   if (selectedRows.some((row) => row.GL === gl && row.EMAIL === email)) {
  //     setSelectedRows(selectedRows.filter((row) => row.GL !== gl || row.EMAIL !== email));
  //   } else {
  //     setSelectedRows([...selectedRows, rowIdentifier]);
  //   }
  // };
  const handleRowSelection = (Value, email, report) => {
    setSelectedRows((prevSelectedRows) => {
      const rowExists = prevSelectedRows.some(
        (row) =>
          row.VALUE === Value &&
          row.EMAIL === email &&
          row.REPORT?.id === report?.id
      );

      if (rowExists) {
        return prevSelectedRows.filter(
          (row) =>
            !(
              row.VALUE === Value &&
              row.EMAIL === email &&
              row.REPORT?.id === report?.id
            )
        );
      } else {
        return [
          ...prevSelectedRows,
          { VALUE: Value, EMAIL: email, REPORT: report },
        ];
      }
    });
  };


  const [editEmail, setEditemail] = useState();

  const handleEdit = (id, email) => {
    setEditemail(email);

    setEditRow({ id, email }); // Storing both id and email
    const rowData = data?.rows?.find(
      (item) => item.VALUE === id && item.EMAIL === email
    );
    setEditedData(rowData ? { ...rowData } : {});
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleKeyDown = (e, field) => {
    if (e.key === "Tab") {
      e.preventDefault();
      const fields = [
        "DISTRIBUTION_CLIENT",
        "VALUE",
        "USER_NAME",
        // "VALUE",
        "EMAIL",
        "LOCATION",
        // "STATUS",
        "COMMENTS",
      ];
      const currentIndex = fields.indexOf(field);
      if (currentIndex !== -1 && currentIndex < fields.length - 1) {
        const nextField = fields[currentIndex + 1];
        document.getElementById(`${editRow.id}-${nextField}`)?.focus();
      }
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      maxHeight: "40px", // Limit height to allow scrolling after 4 items
      overflowY: "auto", // Enable scrolling
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      flexWrap: "wrap",
      maxHeight: "auto", // Limit height for multi-line appearance
      //   overflowY: "auto",
    }),
    multiValue: (provided) => ({
      ...provided,
      // flex: "0 0 48%", // Makes each tag take half the width (for 2 per row)
      margin: "2px", // Adjust spacing
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "auto",
      textOverflow: "ellipsis",
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "900px", // ✅ Limits dropdown height
      overflowY: "auto", // ✅ Enables scrolling
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "200px", // ✅ Ensures items fit within 20px
      overflowY: "auto", // ✅ Allows scrolling inside the menu
    }),
  };
 const fetchData = async ({ searchTerm = "", page } = {}) => {
  setLoader(true);
  setData([]);
  try {
    const queryParams = [];

    const cleanSearchTerm = searchTerm.trim();
    if (cleanSearchTerm) {
      queryParams.push(`search=${encodeURIComponent(cleanSearchTerm)}`);
    }
    const activePage = page ?? currentPage;
    if (activePage) {
      queryParams.push(`page=${activePage}`);
    }

    const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

    const response = await axiosInstance.get(`/data${queryString}`);

      if (response.status == 200) {
      function mergeDuplicateEmails(data) {
        const emailMap = {};
        data.forEach((entry) => {
          const email = entry.EMAIL;
          if (emailMap[email]) {
            const existingRollup = emailMap[email].VALUE.split(",");
            if (!existingRollup.includes(entry.VALUE)) {
              existingRollup.push(entry.VALUE);
            }
            emailMap[email].VALUE = existingRollup.join(", ");
          } else {
            emailMap[email] = { ...entry };
          }
        });

        return Object.values(emailMap);
      }
      const newRows = response?.data?.rows;
      const mergedRows = mergeDuplicateEmails(newRows);

         setData(response?.data);


      if (response?.data?.rows?.length === 0 && activePage !== 1) {
        setCurrentPage(1);
        fetchData({ searchTerm, page: 1 });
      } else {
        setCurrentPage(activePage);
      }
    }

    setLoader(false);
  } catch (error) {
    setLoader(false);
    console.error("Error fetching data:", error);
  }
};

//   const fetchData = async ({ searchTerm = "", page = 1 } = {}) => {
//     setLoader(true);
//     setData([]);
//   try {
//     const queryParams = [];

//     const cleanSearchTerm = searchTerm.trim();
//       if (cleanSearchTerm) {
//         queryParams.push(`search=${encodeURIComponent(cleanSearchTerm)}`);
//       }
//       if (page) {
//         queryParams.push(`page=${page}`);
//       }
//       const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

//     const response = await axiosInstance.get(`/data${queryString}`);

//       if (response.status == 200) {
//         function mergeDuplicateEmails(data) {
//         const emailMap = {};
//         data.forEach((entry) => {
//           const email = entry.EMAIL;
//           if (emailMap[email]) {
//             const existingRollup = emailMap[email].VALUE.split(",");
//             if (!existingRollup.includes(entry.VALUE)) {
//               existingRollup.push(entry.VALUE);
//             }
//             emailMap[email].VALUE = existingRollup.join(", ");
//           } else {
//             emailMap[email] = { ...entry };
//           }
//         });

//         return Object.values(emailMap);
//         }
//         const newRows = response?.data?.rows;
//         const mergedRows = mergeDuplicateEmails(newRows);

//         setData(response?.data);
//         if (response?.data?.rows?.length == 0 && page !== 1) {
//           // setCurrentPage(currentPage);
//           fetchData({ searchTerm, page: 1 });
//         } else {
//           setCurrentPage(currentPage);
//         }
//       }

//       setLoader(false);
//   } catch (error) {
//       setLoader(false);
//     console.error("Error fetching data:", error);
//   }
// };


  const handleExport = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/exportAllReports?page=${currentPage}`,
        {
          responseType: "blob", // important for binary data
        }
      );

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Default filename
      link.setAttribute("download", `users_export_page_${currentPage}_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting users:", error);
    }
  };


  const handleExportRls = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/exportBigQueryData?page=${currentPage}`,
        {
          responseType: "blob", // important for binary data
        }
      );

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Default filename
      link.setAttribute("download", `users_export_page_${currentPage}_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting users:", error);
    }
  };



  const handleUpdateData = async (id) => {
    const requiredFields = [
      "EMAIL",

      "USER_NAME",

      "LOCATION",

      "DISTRIBUTION_CLIENT",
    ];
    const missingFields = requiredFields.filter(
      (field) => !String(editedData[field] || "").trim()
    );

    if (updatedGroup !== undefined && updatedGroup?.length === 0) {
      setToast({
        show: true,

        type: "error",

        message: `Value is required`,
      });
      return;
    }

    if (missingFields.length > 0) {
      setToast({
        show: true,

        type: "error",

        message: `${missingFields.join(", ")} is required`,
      });

      return;
    }
    const originalData = data?.rows?.find((item) => item.VALUE === id);
    // const originalData = data?.rows?.find(
    //   (item) => item.VALUE === id
    // );
    if (!originalData) {
      setToast({
        show: true,
        type: "error",
        message: "Original data not found",
      });
      return;
    }

    function processClientRollup(rollupString, validValues) {
      // Remove extra spaces and split by comma
      const clients = rollupString?.split(",").map((client) => client.trim());
      const processedClients = [];

      // First, add all valid values that exist in both arrays (only once)
      clients.forEach((client) => {
        const isValid = validValues?.some((v) => v.value === client);
        if (isValid && !processedClients?.includes(client)) {
          processedClients?.push(client);
        }
      });

      // Then add all remaining valid values that weren't in the original string
      validValues?.forEach(({ value }) => {
        if (!processedClients?.includes(value)) {
          processedClients?.push(value);
        }
      });

      // Join back with comma
      return processedClients.join(", ");
    }

    let finalData;

    if (updatedGroup === undefined) {
      finalData = groupValue;
    } else {
      finalData = updatedGroup;
    }
    setGroupValue(finalData);

    const myData = processClientRollup(editedData.VALUE, finalData);

    function addBungieToRollup(data, newValue) {
      const key = "VALUE";
      data[key] = newValue;
    }

    addBungieToRollup(editedData, myData);

    const isDataChanged = Object.keys(editedData).some(
      (key) => editedData[key] !== originalData[key]
    );

    if (!isDataChanged) {
      setToast({
        show: true,
        type: "info",
        message: "No changes detected",
      });
      setEditRow(null);
      return;
    }

    editedData.USER_ID = editedData?.EMAIL?.split("@")[0];
    const { COMMENTS, ...restData } = editedData;
    setLoader(true);
    try {
      if (!editedData || Object.keys(editedData).length === 0) {
        throw new Error("No data to update");
      }
      // const payload = { ...editedData, id: id };
      const payload = COMMENTS
        ? { ...restData, COMMENTS, id }
        : { ...restData, id };
      const updatedPayload = Object.fromEntries(
        Object.entries(payload).map(([key, value]) => [key, value ?? ""])
      );
      updatedPayload.actorEmail = actor.actorEmail;
      updatedPayload.actorName = actor.actorName;
      const response = await axiosInstance.post("/update_data", updatedPayload);
      if (response.status == 200 && response?.data) {
        setToast({
          show: true,
          type: "success",
          message: "User updated Successfully",
        });
        setLoader(false);
        setCurrentPage(1);
        fetchData({ searchTerm, page: 1 });
        // setData((prevData) =>
        //     prevData.map((item) => (item.VALUE === id ? { ...editedData } : item))
        // );
      }
      setEditRow(null);
    } catch (error) {
      setToast({
        show: true,
        type: "error",
        message: error.response?.data?.error || "failed",
      });
      setLoader(false);
      console.error("Error posting data:", error);
    }
  };
  const fetchAllRoles = async () => {
    try {
      const response = await axiosInstance.get("/roles");
      if (response.status == 200) {
        setAllRoles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const fetchUser = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getMongoUsers");

      if (response.status === 200) {
        const filteredUsers = response?.data
          ?.map((item) => {
            // Find matching role object from allRoles using _id
            const matchedRoles = allRoles
              .filter((roleItem) => item.role.includes(roleItem._id)) // Match _id with item.role array
              .map((roleItem) => roleItem.role); // Extract role name

            // Exclude users with "Admin" or "Editor" roles
            if (
              matchedRoles.includes("Admin") ||
              matchedRoles.includes("Editor")
            ) {
              return null;
            }

            return {
              value: item._id,
              label: `${item.first_name} ${item.last_name}`,
              email: item.email,
              role: matchedRoles.join(", "), // Join roles if multiple exist
            };
          })
          .filter(Boolean); // Remove null values

        setUserOptions(filteredUsers);
      }
      // setLoader(false);
    } catch (error) {
      setLoader(false);

      console.error("Error fetching roles:", error);
    }
  };
  const fetchReports = async ({ page = currentPageReport, searchTerm }) => {
    setLoader(true);
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", page);
      const cleanSearchTerm = searchTerm?.toString().trim();
      if (cleanSearchTerm) params.append("searchTerm", cleanSearchTerm);
      const response = await axiosInstance.get(
        `/getReports?${params.toString()}`
      );
      if (response.status === 200) {
        setLoader(false);
        setDataReport(response?.data);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching reports:", error);
    }
  };
  const fetchGroupRollUp = async () => {
    try {
      const response = await axiosInstance.get("/client-rollup");
      setRollUpDropdown(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchViewerEmail = async () => {
    setLoader(true);
    try {
      const response = await axiosInstance.get("/getViewerUsers");
      if (response.status === 200) {
        setViewerEmails(response?.data?.users || []);
      }
    } catch (error) {
      console.error("Error fetching viewer emails:", error);
      setToast({
        show: true,
        type: "error",
        message: "Failed to fetch viewer emails",
      });
    } finally {
      setLoader(false);
    }
  };
  const fetchViewerEmailTitle = async () => {
    setLoader(true);
    try {
      const response = await axiosInstance.get("/getViewerUsersTitle");
      if (response.status === 200) {
        setemailOptionTitle(response?.data?.users || []);
      }
    } catch (error) {
      console.error("Error fetching viewer emails:", error);
      setToast({
        show: true,
        type: "error",
        message: "Failed to fetch viewer emails",
      });
    } finally {
      setLoader(false);
    }
  };
  const fetchPipelines = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getPipelines");
      if (response.data) {
        setPipelines(
          response.data?.value?.map((item) => ({
            value: item.id,
            label: item.displayName,
          }))
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching pipelines:", error);
      setLoader(false);
    }
  };
  const fetchWorkspaces = async (selectedPipeline) => {
    try {
      setLoader(true);
      const response = await axiosInstance.post("/Get_all_workspaces", {
        pipelineId: selectedPipeline,
      });
      if (response.data) {
        const cleanedWorkspaces = response.data?.value
          ?.filter(item => item.workspaceId && item.workspaceName)
          .map(item => ({
            value: item.workspaceId,
            label: item.workspaceName,
          }));

        setWorkSpaces(cleanedWorkspaces);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };

  const fetchExistingReport = async (email, reporId) => {
    try {
      setLoader(true);

      const response = await axiosInstance.post("/Get_AdData_email", {
        email: email,
        reporId: reporId,
      });
      if (response?.data) {
        setWorkSpaces(
          response.data?.value?.map((item) => ({
            value: item.workspaceId,
            label: item.workspaceName,
          }))
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoader(false);
    }
  };

  async function checkBigQueryByEmailAndReportId(req, res) {
    const { email, reportId } = req.body;

    // Validate request body
    if (!email || !reportId) {
      return res
        .status(400)
        .json({ message: "Both email and reportId are required." });
    }

    const query = `
        SELECT *
        FROM \`${process.env.RLS_TABLE}\`
        WHERE EMAIL = @EMAIL
        AND EXISTS (
            SELECT id
            FROM UNNEST(REPORT) r
            WHERE r.id = @REPORT_ID
        )
    `;

    const options = {
      query,
      location: "us-east1",
      params: {
        EMAIL: sanitizeString(email),
        REPORT_ID: sanitizeString(reportId),
      },
    };

    try {
      const [rows] = await bigquery.query(options);

      if (rows.length === 0) {
        return res.status(404).json({ message: "No matching record found." });
      }

      return res.status(200).json({
        message: "Matching record(s) found.",
        data: rows,
      });
    } catch (error) {
      console.error("BigQuery Query Error:", error);
      return res.status(500).json({ message: "Internal Server Error" });
    }
  }

  const debouncedSearchTerm = useDebounce(searchTerm, 700);
  useEffect(() => {
    if (debouncedSearchTerm) {
      if (activeTab === "data") {
        fetchData({ searchTerm: debouncedSearchTerm, page: currentPage });
      } else {
        fetchReports({ searchTerm: debouncedSearchTerm, page: currentPage });
      }
    } else {
      fetchData({ searchTerm: "", page: currentPage });
      if (activeTab == "report") {
        fetchReports({ page: currentPageReport, searchTerm: "" });
      }
    }
  }, [debouncedSearchTerm, currentPage, activeTab]);

  useEffect(() => {
    setSearchTerm("");
  }, [activeTab]);

  useEffect(() => {
    // fetchData();
    fetchGroupRollUp();
  }, []);

  const handleCancelEdit = (id, email) => {
    const originalData = data?.rows?.find(
      (item) => item.VALUE === id && item.EMAIL === email
    );
    setEditedData(originalData ? { ...originalData } : {});
    setEditRow({});
    setToast({
      show: true,
      type: "success",
      message: "No Changes were made",
    });
  };

const handleDeleteData = async () => {
  setLoader(true);


  try {
    const body = {
      USER_ID: confirmationModal.id,
      EMAIL: confirmationModal.email,
      REPORT: confirmationModal.report,
      ...actor,
    };


    const response = await axiosInstance.post("/data/delete", body);
      if (response.status == 200) {
        setData((prevData) => ({
          ...prevData,
          rows:
            prevData.rows?.filter(
              (item) => item.VALUE !== confirmationModal.id
            ) || [],
        }));
      setToast({
        show: true,
        type: "success",
          message: "User deleted Successfully",
      });
        setSearchTerm("");
      setConfirmationModal({ show: false, id: "", report: null });

    
      const remainingCount = data?.rows?.length - 1;
      const isLastPageEmpty = remainingCount <= 0 && currentPage > 1;
      const nextPage = isLastPageEmpty ? currentPage - 1 : currentPage;

      await fetchData({ searchTerm, page: nextPage });
      setCurrentPage(nextPage);
    }
      setEditRow(null);

  } catch (error) {
    console.error("Error deleting data:", error);
    setLoader(false);
  }
};

  // const handleDeleteData = async () => {
  //   setLoader(true);


  //   try {
  //     const body = {
  //       USER_ID: confirmationModal.id,
  //       EMAIL: confirmationModal.email,
  //       REPORT: confirmationModal.report,
  //     };


  //     const response = await axiosInstance.post("/data/delete", body);
  //     if (response.status == 200) {
  //       setData((prevData) => ({
  //         ...prevData,
  //         rows:
  //           prevData.rows?.filter(
  //             (item) => item.VALUE !== confirmationModal.id
  //           ) || [],
  //       }));
  //       setToast({
  //         show: true,
  //         type: "success",
  //         message: "User deleted Successfully",
  //       });
  //       setSearchTerm("");
  //       setConfirmationModal({ show: false, id: "", report: null });
  //       // setCurrentPage(1);
  //       await fetchData({ searchTerm, page: currentPage ?? 1});
  //       // fetchData({ searchTerm, page: 1 });
  //       // setData((prevData) => prevData.filter((item) => item.VALUE !== confirmationModal.id));

  //       // fetchData();
  //       setLoader(false);
  //     }
  //     setEditRow(null);
  //   } catch (error) {
  //     console.error("Error deleting data:", error);
  //     setLoader(false);
  //   }
  // };
  const handleDeleteSelectedRows = async () => {
    setLoader(true);
  if (selectedRows.length === 0) {
    setToast({
      show: true,
        type: "success",
        message: "No Record selected",
    });
      setLoader(false);
    return;
  }
  try {
    const rowsToDelete = selectedRows.map(({ VALUE, EMAIL, REPORT }) => ({
      USER_ID: VALUE,
        EMAIL: EMAIL,
        REPORT: REPORT,
    }));
    const response = await axiosInstance.post("/data/deleteRow", {
      rows: rowsToDelete,
      ...actor,
    });
      const result = await response.data;
    if (response.status === 200) {
      setToast({
        show: true,
        type: "success",
          message: result.message,
      });
  //  setSearchTerm("")
  // setCurrentPage(1);
  // fetchData({ searchTerm, page: 1 });
  // setLoader(false);
      // Update local state immediately for instant UI feedback
     setData((prevData) => {
          if (Array.isArray(prevData)) {
            return prevData.filter(
              (item) =>
                !selectedRows.some(
                  (row) => row.VALUE === item.VALUE && row.EMAIL === item.EMAIL
                )
            );
          } else {
            console.error("prevData is not an array:", prevData);
            return prevData;
          }
        });

      setSelectedRows([]);

      const remainingCount = data?.rows?.length - selectedRows.length;
      const isLastPageEmpty = remainingCount <= 0 && currentPage > 1;
      const nextPage = isLastPageEmpty ? currentPage - 1 : currentPage;

      await fetchData({ searchTerm, page: nextPage });
      setCurrentPage(nextPage);
    }
  } catch (error) {
    console.error("Error deleting data:", error);
    }
  };

  const handleDeleteSelectedReports = async () => {
    setLoader(true);
    if (selectedReportRows.length === 0) {
      setToast({
        show: true,
        type: "success",
        message: "No Record selected",
      });
      setLoader(false);
      return;
    }

    try {
      const emailsArray = selectedReportRows.map((row) => row.email);
      const response = await axiosInstance.delete("/multiple_deleteReport", {
        data: { emails: emailsArray, ...actor },
      });



      const result = await response.data;
      if (response.status === 200) {
        setToast({
          show: true,
          type: "success",
          message: result.message || "Reports deleted successfully",
        });
        setSearchTerm("")
        setLoader(false);
        setSelectedReportRows([]);
           const remainingCount = dataReport?.rows?.length - 1;
      const isLastPageEmpty = remainingCount <= 0 && currentPage > 1;
      const nextPage = isLastPageEmpty ? currentPage - 1 : currentPage;

      await fetchReports({ page: nextPage, searchTerm });
      setCurrentPage(nextPage);
      } else {
        console.error("Error response:", result);
      }
    } catch (error) {
      setToast({
        show: true,
        type: "error",
        message: "Failed to delete reports",
      });
      setLoader(false);
      console.error("Error deleting reports:", error);
    }
  };

  const fetchAllReports = async () => {
    try {
      const response = await axiosInstance.get(`/bookmarks`);
    console.log(response.data, 'responsebookmarks');

      if (response.status === 200) {
        const data = response.data;


    console.log("data535",data)
        const selectedReports = data
          .filter((item) => item?.type === "Web Application")
          .map((item) => ({
            value: item._id,
            label: item.title,
          }));

        // The rest of the reports
        const otherReports = data
          .filter((item) => item?.type !== "Web Application")
          .map((item) => ({
            value: item._id,
            label: item.title,
          }));

      console.log('Selected Reports:', selectedReports,'otherReports',otherReports);
        setReportOptions(otherReports); //setting report options
        setReportId(selectedReports); // setting application options
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // const pipelineIds=selectedReport.PIPELINE?.[0] ? selectedReport.PIPELINE?.[0]?.id :""
const pipelineIds =
  selectedReport?.PIPELINE?.[0]?.id || "";

console.log(selectedReport?.PIPELINE?.[0]?.id,'selectedReport',pipelineIds)

  useEffect(() => {
  fetchData({ page: currentPage });
    fetchAllRoles();
    fetchAllReports();
  }, []);
  useEffect(()=>{
    console.log(currentPage,'currentpage124')
  },[currentPage])

  useEffect(() => {
    if (allRoles) {
      fetchUser();
    }
  }, [allRoles]);

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    setCurrentPage(1);
    // fetchData({ searchTerm: newSearchTerm, page: 1 });
  };
  const handleClearReportData = () => {
    setSearchTerm("");
    setCurrentPage(1);
    setRefreshKey((prevKey) => prevKey + 1); // Force re-render of child component
    setResetReports(true);
    setSelectedReportRows([]);
  };
  const handleClearSearch = () => {
    setSearchTerm("");
    setCurrentPage(1);
    setEditRow(null);
    setEditedData({});
    setSelectedRows([]);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  // const [transformedRoll, settransformedRoll] = useState(rollUpDropdown)
  // // const [transformedValue, setTransformedValue] = useState(ValueField)

  // useEffect(() => {
  //   const transformedArray = rollUpDropdown.map((item) => ({
  //     value: item.GROUP_3,
  //     label: item.GROUP_3,
  //   }));

  //   settransformedRoll(transformedArray)
  // }, [rollUpDropdown])
  // // const [transformedRoll, settransformedRoll] = useState(rollUpDropdown)
  // //   const valueOptions = ValueField.map((item) => ({
  // //   label: item.GROUP_3,
  // //   value: item.GROUP_3,
  // // }));

  const [transformedValue, setTransformedValue] = useState(ValueField);
  // useEffect(() => {
  //   const transformedArray = rollUpDropdown.map(item => ({
  //     value: item.GROUP_3,
  //     label: item.GROUP_3
  //   }));

  //   settransformedRoll(transformedArray)
  // }, [rollUpDropdown])

  useEffect(() => {
    const transformedArray = ValueField.map((item) => ({
      value: item.GROUP_3,
      label: item.GROUP_3,
    }));

    setTransformedValue(transformedArray);
  }, [ValueField]);

  function getUserByEmail(email) {
    const user = data?.rows?.find((user) => user.EMAIL === email);

    if (!user) return null;

    // Convert VALUE string into an array of objects
    user.VALUE = user.VALUE.split(",")
      .map((group) => group.trim()) // Trim whitespace
      .map((group) => ({ value: group, label: group })); // Convert to object

    return user;
  }
  function convertGroupRollupToOptions(groupRollup) {
    return groupRollup.split(",").map((group) => ({
      value: group,
      label: group,
    }));
  }

  useEffect(() => {
    const selectEdit =
      data?.rows?.find((user) => {
        return user.EMAIL === editEmail && user.VALUE == editRow?.id;
      }) || null;

  

    if (selectEdit) {
      const formattedData = convertGroupRollupToOptions(selectEdit?.VALUE);

      setGroupValue(formattedData);
    }
  }, [editEmail, editRow]);
  const handleGroupChange = (group, value) => {
    setupdatedGroup(value.length > 0 ? value : []); // Allow empty selection
  };

  const handleUpdateOpen = () => {
    setIsEditMode(true);
    setShowModal(true);
  };



  return (
    <div className="flex flex-col h-full relative w-full">
      {showModal && (
        <AddDataModal
          setCurrentPage={setCurrentPage}
          searchTerm={searchTerm}
          fetchAllReports={fetchAllReports}
          isOpen={showModal}
          isEditMode={isEditMode}
          setShowModal={setShowModal}
          // onClose={handleClose}
          rollUpDropdown={rollUpDropdown}
          ValueField={ValueField}
          fetchData={fetchData}
          tableReport={tableReport}
          fetchTableReports={fetchTableReports}
          fetchFieldTable={fetchFieldTable}
          fetchValueField={fetchValueField}
          fetchViewerEmail={fetchViewerEmail}
          fetchViewerEmailTitle={fetchViewerEmailTitle}
          fetchPipelines={fetchPipelines}
          fetchExistingReport={fetchExistingReport}
          fetchWorkspaces={fetchWorkspaces}
          setIsEditMode={setIsEditMode}
          editDataExisting={selectedReport}
          workSpaceReports={workSpaceReports}
          fetchWorkspacesReports={fetchWorkspacesReports}
          data={data}
        />
      )}

      {showReport && (
        <AddReportsDataModal
          searchTerm={searchTerm}
          isOpen={showModal}
          onClose={() => setShowReport(false)}
          fetchReports={fetchReports}
          userOptions={userOptions}
        />
      )}
      {confirmationModal.show && (
        <ConfirmationModal
          onDelete={handleDeleteData}
          isOpen={confirmationModal}
          onClose={() => setConfirmationModal({ id: "", show: false })}
          title={"Are you sure, you want to delete this user? "}
        />
      )}

      <div className="flex-shrink-0">
        <div className="flex flex-col md:flex-row justify-end border-b mb-2 items-center">
          <div className="w-full flex md:mb-0 mb-2 ">
            <button
              className={`px-6 w-full md:mb-0 mb-2 md:w-auto font-medium ${activeTab === "report"
                  ? "border-b-2 border-[#F87171] text-[#F87171]"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("report")}
            >
              {/* Report */}
              Assign Reports/Dashboards
            </button>
            <button
              className={`px-6 w-full md:mb-0 mb-2 md:w-auto font-medium ${activeTab === "data"
                  ? "border-b-2 border-[#F87171] text-[#F87171]"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("data")}
            >
              {/* Data */}
              RLS (Data)
            </button>
          </div>
          {/* Search Input */}
          <div className="flex md:justify-end justify-start w-full md:w-auto">
            {activeTab === "data" && (
              <div className="flex w-full md:w-auto items-center mb-2">
                <div className="flex gap-1 md:gap-0 flex-col md:flex-row items-center space-x-2 w-full">
                  {/* Search Input Container */}
                  <div className="relative  flex flex-col md:flex-row items-center md:w-auto w-full  ">
                    <FaSearch className="absolute left-3 top-3 sm:top-3.5  text-gray-500" />
                    <input
                      type="text"
                      placeholder="Search"
                      className="py-2 px-2 pl-10 sm:text-[14px] text-[11px]  rounded-lg border-[2px] md:w-[280px] w-full focus:border-blue-500 focus:outline-none"
                      value={searchTerm ?? ""}
                      onChange={handleSearchChange}
                      onPaste={(e) => {
                        e.preventDefault();
                        const text = e.clipboardData.getData("text").trim();
                        setSearchTerm(text);
                      }}
                    />
                  </div>
                  <div className="flex gap-2 mt-2 md:mt-0">
                    <button
                      className={`text-white sm:text-[14px] text-[11px] w-full md:w-auto  px-8 sm:px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${loader || !searchTerm.length
                          ? "bg-[#F87171] cursor-not-allowed"
                          : "bg-[#e31c23] cursor-pointer"
                      } transition-colors duration-200 active:bg-[#F87171]`}
                      disabled={!searchTerm.length}
                      onClick={handleClearSearch}
                    >
                      Clear
                    </button>

                    <button
                      className={`sm:px-2 px-6 sm:text-[14px] text-[11px]  ${loader ? "bg-[#F87171]" : "bg-[#e31c23]"
                      } text-white py-2 w-full rounded-lg focus:outline-none border-none whitespace-nowrap transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={() => {
                        setShowModal(true)
                        setRlsType("report")
                        setSelectedReport()
                      }
                      }
                    >
                      Add RLS
                    </button>
                    <button
                      className={`sm:px-2 px-6 sm:text-[14px] text-[11px]  ${loader ? "bg-[#F87171]" : "bg-[#e31c23]"
                      } text-white py-2 w-full rounded-lg focus:outline-none border-none whitespace-nowrap transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={() => handleExportRls(currentPage)}
                    >
                      Export All

                    </button>
                    <button
                      className={`sm:px-2 px-6 sm:text-[14px] text-[11px]  ${loader ? "bg-[#F87171]" : "bg-[#e31c23]"
                      } text-white w-full py-2 rounded-lg focus:outline-none border-none whitespace-nowrap transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={handleDeleteSelectedRows}
                    >
                      Delete All
                    </button>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "report" && (
              <div className="flex justify-between md:w-auto items-center mb-1 w-full ">
                <div className="flex flex-col gap-1 sm:gap-0 sm:flex-row justify-end items-center space-x-2 w-full">
                  <div className="relative  flex flex-col md:flex-row items-center md:w-auto w-full">
                    <FaSearch className="absolute left-3 top-3 sm:top-3.5  text-gray-500" />
                    <input
                      type="text"
                      placeholder="Search"
                      className="py-2 px-2 pl-10 sm:text-[14px] text-[11px]  rounded-lg border-[2px] md:w-[280px] w-full focus:border-blue-500 focus:outline-none"
                      value={searchTerm ?? ""}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onPaste={(e) => {
                        e.preventDefault();
                        const text = e.clipboardData.getData("text").trim();
                        setSearchTerm(text);
                      }}
                    />
                  </div>
                  <div className="flex gap-2 m-2 md:m-0">
                    <button
                      className={`text-white w-full text-[12px] sm:text-[14px] sm:px-4 px-8 py-2 rounded-lg focus:outline-none whitespace-nowrap ${loader || !searchTerm.length
                          ? "bg-[#F87171] cursor-not-allowed"
                          : "bg-red-600 cursor-pointer"
                      } transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={handleClearReportData}
                      disabled={!searchTerm.length}
                    >
                      Clear
                    </button>
                    <button
                      className={`text-white w-full  text-[12px] sm:text-[14px] px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${loader ? "bg-[#F87171]" : "bg-red-600"
                      } transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={() => setShowReport(true)}
                    >
                      {/* Add Report */}
                      Assign Reports
                    </button>
                    <button
                      className={`text-white w-full  text-[12px] sm:text-[14px] px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${loader ? "bg-[#F87171]" : "bg-red-600"
                      } transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={() => handleExport(currentPage)}
                    >
                      {/* Add Report */}
                      Export All
                    </button>
                    <button
                      className={`sm:px-2 px-6 sm:text-[14px] text-[11px]  ${loader ? "bg-[#F87171]" : "bg-[#e31c23]"
                      } text-white w-full py-2 rounded-lg focus:outline-none border-none whitespace-nowrap transition-colors duration-200 active:bg-[#F87171]`}
                      onClick={handleDeleteSelectedReports}
                    >
                      Delete All
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {activeTab === "data" ? (
        <>
          <div
            className={`w-[400px]   max-w-full min-w-full overflow-auto`}
          >
            <table
              key={refreshKey}
              // className={` ${
              //   data?.rows?.length > 5 ? "h-full" : ""
              // }  table-auto border border-gray-300 text-[12px]`}
              className="w-full table-auto rounded-lg border-2 border-gray-300"
            >
              <thead className="bg-gray-200 text-gray-700 z-10 sticky top-0">
                <tr className="sm:text-[12px] text-[10px]">
                  <th className="border py-2 text-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      onChange={handleSelectAll}
                      // checked={
                      //   selectedRows.length === data?.rows?.length &&
                      //   data?.rows?.length > 0
                      // }
                       checked={
                          data?.rows?.length > 0 &&
                          data?.rows.every((row) =>
                            selectedRows.some(
                              (selected) =>
                                selected.VALUE === row.VALUE &&
                                selected.EMAIL === row.EMAIL &&
                                selected.REPORT?.id === (
                                  Array.isArray(row.REPORT) ? row.REPORT[0]?.id : row.REPORT?.id
                                )
                            )
                          )
                        }
                    />
                  </th>
                  {[
                    { heading: "Distribution Client" },
                    // { heading: "GL Client Rollup", widthClass: "min-w-[220px]" },
                    { heading: "User Name", widthClass: "min-w-[100px]" },
                    { heading: "User ID", widthClass: "min-w-[120px]" },
                    { heading: "Email", widthClass: "min-w-[160px]" },
                    { heading: "Location", widthClass: "min-w-[80px]" },
                    // { heading: "Status", widthClass: "min-w-[80px]" },
                    { heading: "Report Title / Application Title", widthClass: "min-w-[150px]" },
                    { heading: "Pipeline", widthClass: "min-w-[150px]" },
                    { heading: "WorkSpace", widthClass: "min-w-[150px]" },
                    { heading: "Report/Application", widthClass: "min-w-[200px]" },
                    { heading: "Table", widthClass: "min-w-[150px]" },
                    { heading: "Field(Column)", widthClass: "min-w-[150px]" },
                    { heading: "Value", widthClass: "min-w-[150px]" },
                    { heading: "Comments", widthClass: "min-w-[100px]" },
                    { heading: "Actions", widthClass: "min-w-[70px]" },
                  ].map((item, index) => (
                    <th
                      key={index}
                      className={`border py-1 text-center whitespace-nowrap ${item.widthClass}`}
                    >
                      {item.heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.rows?.length > 0 ? (
                  data?.rows?.map((item, index) => {
                    const isChecked = selectedRows.some(
                      (row) =>
                        row.VALUE === item.VALUE &&
                        row.EMAIL === item.EMAIL &&
                        row.REPORT?.id === (Array.isArray(item.REPORT) ? item.REPORT[0]?.id : item.REPORT?.id)
                    );

                    const userId = item.EMAIL?.split("@")[0] || "";
                    return (
                      <tr
                        key={`${item.VALUE}-${item.EMAIL}-${index}`}
                        // key={`${item.Value}-${item.EMAIL}-${index}`}
                        className="border-b leading-tight sm:text-[12px] text-[10px] md:py-[0px] lg:py-[0px] 2xl:py-[0px] sm:py-[0px]"
                      >
                        <td className="border px-2 td-1920 td-1520 td-1000 td-2220  text-center">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() =>
                              handleRowSelection(
                                // item.VALUE,
                                item.VALUE,
                                item.EMAIL,
                                Array.isArray(item.REPORT)
                                  ? item.REPORT[0]
                                  : item.REPORT
                              )
                            }
                          />
                        </td>
                        {[
                          "DISTRIBUTION_CLIENT",
                          // "VALUE",
                          "USER_NAME",
                          "USER_ID",
                          "EMAIL",
                          "LOCATION",
                          // "STATUS",
                          "REPORT_TITLE",
                          "PIPELINE",
                          "WORKSPACE",
                          "REPORT",
                          "TABLE",
                          "COLUMN",
                          "VALUE",
                          "COMMENTS",
                        ].map((field) => (
                          <td
                            key={field}
                            className="border text-center whitespace-nowrap max-w-[80px] overflow-x-auto px-2 py-1"
                            // title={item[field] ? item[field] : ""}
                            title={
                              Array.isArray(item[field])
                                ? item[field].map((d) => d.name || d.label).join(", ")
                                : typeof item[field] === "object" && item[field] !== null
                                ? item[field].name || item[field].label || ""
                                : item[field] ?? ""
                            }
                          >
                            {isFirefox ? (
                              <div className="whitespace-nowrap max-w-[120px] overflow-x-auto p-2">
                                {editRow?.id === item.VALUE &&
                                editRow?.email === item.EMAIL ? (
                                  field === "STATUS" ? (
                                    <select
                                      id={`${item.VALUE}-${field}`}
                                      value={
                                        editedData[field] ?? item[field] ?? ""
                                      }
                                      onChange={(e) => handleChange(e, field)}
                                      className="min-w-[50px] max-w-[80px] px-1 py-1 rounded border border-gray-300 outline-none"
                                    >
                                      {[0, 1].map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>
                                  ) : field === "VALUE" ? (
                                    <Select
                                      options={transformedValue}
                                      isMulti
                                      menuPlacement="auto"
                                      value={
                                        updatedGroup !== undefined
                                          ? updatedGroup
                                          : groupValue
                                      }
                                      onChange={(selected) => {
                                        let values = Array.isArray(selected)
                                          ? [...selected]
                                          : [];
                                        if (
                                          values.some(
                                            (opt) => opt.value === "*"
                                          )
                                        ) {
                                          values = [{ value: "*", label: "*" }];
                                        } else {
                                          // If "*" was already selected earlier and now user selects others -> remove "*"
                                          values = values.filter(
                                            (opt) => opt.value !== "*"
                                          );
                                        }

                                        handleGroupChange("group", values);
                                      }}
                                      menuShouldScrollIntoView={false}
                                      menuPortalTarget={document.body}
                                      className="outline-none focus:outline-none 333"
                                      classNamePrefix="react-select"
                                      styles={customStyles}
                                    />
                                  ) : (
                                    <input
                                      id={`${item.VALUE}-${field}`}
                                      // id={`${item.Value}-${field}`}
                                      type="text"
                                      // value={editedData[field] || ""}
                                      value={
                                        Array.isArray(
                                          editedData[field] || item[field]
                                        )
                                          ? (editedData[field] || item[field])
                                              .map((d) => d.name || d.label)
                                              .join(",")
                                          : typeof (
                                              editedData[field] || item[field]
                                            ) === "object" &&
                                            (editedData[field] ||
                                              item[field]) !== null
                                          ? (editedData[field] || item[field])
                                              .name ||
                                            (editedData[field] || item[field])
                                              .label ||
                                            ""
                                          : editedData[field] ??
                                            item[field] ??
                                            ""
                                      }
                                      onChange={(e) => handleChange(e, field)}
                                      onKeyDown={(e) => handleKeyDown(e, field)}
                                      className="w-full px-2 text-center rounded border-none outline-none 444"
                                    />
                                  )
                                ) : Array.isArray(item[field]) ? (
                                  item[field]
                                    .map((d) => d.name || d.label)
                                    .join(",")
                                ) : typeof item[field] === "object" &&
                                  item[field] !== null ? (
                                  item[field].name || item[field].label || ""
                                ) : (
                                  item[field] ?? ""
                                )}
                              </div>
                            ) : editRow?.id === item.VALUE &&
                              editRow?.email === item.EMAIL ? (
                              field === "STATUS" ? (
                                <select
                                    id={`${item.VALUE}-${field}`}
                                    // id={`${item.Value}-${field}`}
                                    // value={editedData[field] || item[field]}
                                    value={
                                      editedData[field] ?? item[field] ?? ""
                                    }
                                    onChange={(e) => handleChange(e, field)}
                                    className="min-w-[50px] max-w-[80px] px-1 py-1 rounded border border-gray-300 outline-none"
                                  >
                                    {[0, 1].map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                              ) : field === "VALUE" ? (
                                <Select
                                  // options={transformedRoll}
                                  options={transformedValue}
                                  isMulti
                                  menuPlacement="auto"
                                  value={
                                    updatedGroup !== undefined
                                      ? updatedGroup
                                      : groupValue
                                  } // Ensure empty state is allowed
                                  // onChange={(selected) => handleGroupChange("group", selected)}
                                  onChange={(selected) => {
                                    // Ensure always an array
                                    let values = Array.isArray(selected)
                                      ? [...selected]
                                      : [];
                                    // If "*" is selected
                                    if (
                                      values.some((opt) => opt.value === "*")
                                    ) {
                                      // Keep only "*"
                                      values = [{ value: "*", label: "*" }];
                                    } else {
                                      // If "*" was already selected earlier and now user selects others -> remove "*"
                                      values = values.filter(
                                        (opt) => opt.value !== "*"
                                      );
                                    }

                                    handleGroupChange("group", values);
                                  }}
                                  menuShouldScrollIntoView={false}
                                  menuPortalTarget={document.body}
                                  className="outline-none focus:outline-none 333"
                                  classNamePrefix="react-select"
                                  styles={customStyles}
                                />
                              ) : (
                               <input
                                  id={`${item.VALUE}-${field}`}
                                  // id={`${item.Value}-${field}`}
                                  type="text"
                                  // value={editedData[field] || ""}
                                  value={
                                    Array.isArray(
                                      editedData[field] || item[field]
                                    )
                                      ? (editedData[field] || item[field])
                                        .map((d) => d.name || d.label)
                                        .join(",")
                                      : typeof (
                                        editedData[field] || item[field]
                                      ) === "object" &&
                                        (editedData[field] || item[field]) !==
                                        null
                                        ? (editedData[field] || item[field])
                                          .name ||
                                        (editedData[field] || item[field])
                                          .label ||
                                        ""
                                        : editedData[field] ?? item[field] ?? ""
                                  }
                                  onChange={(e) => handleChange(e, field)}
                                  onKeyDown={(e) => handleKeyDown(e, field)}
                                  className="w-full px-2 text-center rounded border-none outline-none 444"
                                />
                              )
                            ) : Array.isArray(item[field]) ? (
                              item[field]
                                .map((d) => d.name || d.label)
                                .join(",")
                            ) : typeof item[field] === "object" &&
                              item[field] !== null ? (
                              item[field].name || item[field].label || ""
                            ) : (
                              item[field] ?? ""
                            )}
                          </td>
                        ))}
                        {/* <td className="border px-2 py-1 text-center whitespace-nowrap">
                          {userId}
                        </td> */}
                        <td className="px-2 py-[12px] text-center flex justify-center gap-3">
                          {editRow?.id === item.VALUE &&
                          editRow?.email === item.EMAIL ? (
                            <>
                              <FaSave
                                className="text-green-600 cursor-pointer"
                                onClick={() => handleUpdateData(item.VALUE)}
                              />
                              <FaTimes
                                className="text-gray-600 cursor-pointer"
                                onClick={() => {
                                  handleCancelEdit(item.VALUE, item.EMAIL);
                                  setupdatedGroup(undefined);
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <FaEdit
                                className={`${isChecked
                                    ? "cursor-not-allowed text-blue-400"
                                    : "cursor-pointer text-blue-600"
                                }`}
                                //   onClick={() => {
                                //     setSelectedReport(item);
                                //     handleUpdateOpen();
                                //     // setupdatedGroup(undefined);

                                //     // !isChecked &&
                                //     //   handleEdit(item.VALUE, item.EMAIL);
                                // if (pipelineIds) {
                                //   setRlsType("report");
                                // } else {
                                //   setRlsType("application");
                                // }
                                //   }}
                                onClick={() => {
                                  setSelectedReport(item);
                                  handleUpdateOpen();

                                  const pipelineId = item?.PIPELINE?.[0]?.id;

                                  if (pipelineId && pipelineId.trim() !== "") {
                                    setRlsType("report");
                                  } else {
                                    setRlsType("application");
                                  }
                                }}
                              />
                              <FaTrash
                                className={`${isChecked
                                    ? "cursor-not-allowed text-red-400"
                                    : "cursor-pointer text-red-600"
                                }`}
                                onClick={() => {
                                  if (!isChecked) {
                                    setConfirmationModal({
                                      id: item.VALUE,
                                      email: item.EMAIL,
                                      show: true,
                                      report: item.REPORT?.[0],
                                    });
                                  }
                                }}
                              />
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={9}
                      className="text-center py-4 text-gray-500 font-semibold"
                    >
                      {loader ? "Loading..." : "Users Not Found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* {(data?.totalPages >= 1 || searchTerm) && (
            <div className="w-full flex justify-end mt-2">
              <Pagination
                selectedRows={selectedRows.length}
                totalItems={data.totalRecords}
                itemsPerPage={10}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            </div>
          )} */}
          {data?.rows?.length > 0 && (
            <div className="w-full flex absolute bottom-0 justify-end mt-2">
              <Pagination
                selectedRows={selectedRows.length}
                totalItems={data.totalRecords}
                itemsPerPage={10}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </>
      ) : (
        <DataReports
          dataReport={dataReport}
          setDataReport={setDataReport}
          refreshKey={refreshKey}
          resetReports={resetReports}
          setResetReports={setResetReports}
          selectedRows={selectedReportRows}
          setSelectedRows={setSelectedReportRows}
          setSearchTerms={setSearchTerm}
        />
      )}
    </div>
  );
};

export default UserTable;
